module.exports = __webpack_public_path__ + "0cb81712c36157302d169314edb86927.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/clouds.png
// module id = 3165
// module chunks = 0